import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React, {Suspense} from 'react';
import UbiSectionLoadingKr from '@di-shared/features/home/kr/benefit/UbiSectionLoading.kr';
import {ErrorBoundary} from 'react-error-boundary';
import UbiSectionErrorKr from '@di-shared/features/home/kr/benefit/UbiSectionError.kr';
import UbiSectionKr from '@di-shared/features/home/kr/benefit/UbiSection.kr';
import HomeMileageKr, {HomeMileageLoading} from '@di-shared/features/home/kr/benefit/HomeMileage.kr';
import useAvailableComponentKr from '@di-shared/features/home/kr/useAvailableComponent.kr';
import {PermissionTypeKr} from '@di-shared/api/di/type';
import HomeMileageDisconnectionNoticeKr from '@di-shared/features/home/kr/benefit/HomeMileageDisconnectionNotice.kr';
import HomeMileageBeforeAgreementKr from '@di-shared/features/home/kr/benefit/HomeMileageBeforeAgreement.kr';
import MileageConditionalRenderer from '@di-shared/features/mileage/ecomileage/MileageConditionalRenderer';
import {TabType} from '@di-shared/features/home/kr/HomeContents.kr';

export interface BenefitContentsKrProps {
  vin: string;
}

function BenefitContentsKr({vin}: BenefitContentsKrProps) {
  const {t} = useInferableTranslation();
  const {checkAvailableComponent} = useAvailableComponentKr({vin});

  return (
    <div className="tab_content benefits">
      <section
        className="section"
        id={`${TabType.Benefit}_tabpanel`}
        aria-labelledby={`${TabType.Benefit}_tab`}
      >
        <h2 className="blind">{t('T20051')}</h2>
        {/* 서울시 마일리지 */}
        <MileageConditionalRenderer
          vin={vin}
          ifNotSupported={() => <></>}
          ifSupportedNotAgree={(openMileageSingUpBottomSheet) => <HomeMileageBeforeAgreementKr onClick={openMileageSingUpBottomSheet} />}
          ifAgree={(checkAndGotoMileagePage) => (
            <HomeMileageKr
              vin={vin}
              onClick={checkAndGotoMileagePage}
            />
          )}
          loadingFallback={<HomeMileageLoading />}
        />
        {checkAvailableComponent(PermissionTypeKr.SEOUL) && (
          <ErrorBoundary fallback={<></>}>
            <Suspense fallback={<></>}>
              <HomeMileageDisconnectionNoticeKr vin={vin} />
            </Suspense>
          </ErrorBoundary>
        )}
        {checkAvailableComponent(PermissionTypeKr.UBI) && (
          <ErrorBoundary fallback={<UbiSectionErrorKr vin={vin} />}>
            <Suspense fallback={<UbiSectionLoadingKr />}>
              <UbiSectionKr vin={vin} />
            </Suspense>
          </ErrorBoundary>
        )}
      </section>
    </div>
  );
}

export default BenefitContentsKr;
